import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

export function generateFormObject(schema: any, formData: any, allowNull: boolean = false) {
  allowNull = allowNull || false;
  const $formData = cloneDeep(formData);
  return schema.fields.reduce((prev: any, field: any) => {
    if ($formData[field.code] || (allowNull && $formData[field.code] === 0)) {
      switch(field.type) {
        case 'interval':
          prev[field.code] = moment(0).utc().local(true).add($formData[field.code].secs, 'seconds').toDate();
          break;
        case 'date':
        case 'timestamp':
        case 'datetime': {
          prev[field.code] = moment($formData[field.code]).toDate();
          break;
        }
        case 'time': {
          prev[field.code] = moment($formData[field.code], 'HH:mm:ss').toDate();
          break;
        }
        case 'decimal': {
          prev[field.code] = parseFloat($formData[field.code]);
          break;
        }
        case 'credentials': {
          if ($formData[field.code]) {
            prev[field.code] = {
                ...$formData[field.code],
                password: null,
                repeatPassword: null,
            }
          }
          break;
        }
        default: {
          prev[field.code] = $formData[field.code];
        }
      }
    } else {
      prev[field.code] = null;
    }

    return prev;
  }, {})
}

